<!-- header.component.html -->
<div class="preview-modal-container">
  <header
    class="preview-header bg-header dark:bg-dark-header text-white shadow w-full dark:border-dark-header dark:border-b"
    *ngIf="isLoaded">
    <div class="flex justify-between items-center h-16  w-full px-2">
      <!-- Default/WARFIGHTERS theme -->
      <div class="flex mr-2 flex-shrink-0 flex-row gap-1 px-4 rounded-md border-gray-50"
        *ngIf="currentTheme === 'WARFIGHTERS' ">
        <img class=" logo" alt="OE" src="./../../../assets/logos/oe logo.png" priority />
        <div class="title-container">
          <span class="text-lg text-black font-bold">OSD WARFIGHTERS</span>
          <span class="sub-title text-black font-light">Touchpoint</span>
        </div>
      </div>

      <!-- PavCon theme -->
      <div class="flex flex-shrink-0 flex-row gap-1 rounded-md border-gray-50 relative -ml-4 pl-4 h-[72px]"
        *ngIf="currentTheme === 'PavCon'">
        <div class="absolute inset-y-0 left-0 w-[200px] bg-gradient-to-r from-white/95 via-white/50 to-transparent">
        </div>
        <div class="relative z-10">
          <img class="h-12 mt-4" alt="PavCon" src="./../../../assets/logos/pavcon.png" priority />
        </div>
        <div class="title-container relative z-10">
          <span class="text-lg text-white font-bold">Data Capture</span>
          <span class="sub-title text-white font-medium">Platform</span>
        </div>
      </div>

      <!-- SAFiRE theme -->
      <div class="flex flex-shrink-0 flex-row gap-1 rounded-md border-gray-50 relative -ml-4 pl-4 h-[72px]"
        *ngIf="currentTheme === 'SAFiRE'">
        <div class="absolute inset-y-0 left-0 w-[200px] bg-gradient-to-r from-white/95 via-white/50 to-transparent">
        </div>
        <div class="relative z-10">
          <img class="h-16 mt-0" alt="SAFiRE" src="./../../../assets/logos/safire.png" priority />
        </div>
        <div class="title-container relative z-10">
          <span class="text-lg text-white font-bold">FY26 Submissions</span>
          <span class="sub-title text-white font-medium">Call for Proposals</span>
        </div>
      </div>

      <div class="ml-4 flex flex-row items-end gap-3 md:ml-6">


        <button class="primary-button flex flex-row gap-2 items-center justify-center h-[35px]"
          (click)="generatePdfSurvey()" [disabled]="isPrintLoading" title="Generate PDF and print (recommended)">
          <lucide-angular *ngIf="!isPrintLoading" name="printer" class="w-5 h-5"></lucide-angular>
          <div *ngIf="isPrintLoading" class="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
          <span>{{ isPrintLoading ? 'Generating...' : 'PDF Print' }}</span>
        </button>


        <button class="secondary-button flex flex-row gap-2 items-center justify-center h-[35px]" (click)="close()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
            <path fill-rule="evenodd"
              d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
              clip-rule="evenodd" />
          </svg>
          <span>Close Preview</span>
        </button>
      </div>
    </div>
  </header>

  <div class="flex flex-col" style="height: 736px;">
    <div class="overflow-y-auto">
      <app-survey-preview *ngIf="previewId" [previewId]="previewId"></app-survey-preview>
    </div>
  </div>
</div>

<!-- @if(previewId){ -->
<!-- } @else {
<iframe [src]="safeUrl" (load)="onIframeLoad()" width="100%" height="100%"></iframe>
} -->

<!--
<iframe [src]="safeUrl" (load)="onIframeLoad()" width="100%" height="100%"
  allow="fullscreen *; scripts *; same-origin *"
  sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-modals allow-top-navigation allow-presentation"
  referrerpolicy="same-origin"></iframe> -->